import React, { useRef } from "react"
import MaterialButton from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"
import { green } from "@material-ui/core/colors"
import classnames from "classnames"
import clsx from "clsx"
import Progress from "./progress"
// import { MaterialButton } from "@material-ui/core"

/**
 * @param {{
 * children?,
 * disabled?,
 * onClick?,
 * variant?,
 * component?,
 * color?,
 * loading?,
 * loadingText?,
 * wrapped?,
 * errorMessage?,
 * className?,
 * rounded?,
 * startIcon?,
 * endIcon?,
 * buttonRef?,
 * wrapperStyling?,
 * staticButton?,
 * size?,
 * time?:number
 * id?
 * }} param1
 */
function _Button({
  children,
  disabled,
  onClick,
  variant,
  component,
  color,
  loading,
  loadingText,
  wrapped,
  errorMessage,
  className,
  rounded = false,
  startIcon,
  endIcon,
  time=2000,
  buttonRef,
  wrapperStyling = false,
  staticButton = false,
  size,
  id,
}) {
  const useStyles = makeStyles(theme => ({
    buttonProgress: {
      color: green[500],
      display: "inline-block",
      verticalAlign: "middle",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
      },
    },
    internalButton: {
      position: "absolute",
      marginLeft: 0,
    },
    wrapper: {
      position: "relative",
    },
    buttonLoadingText: {
      color: green[500],
      marginLeft: 10,
      display: "inline-block",
    },
    errorMessage: {
      color: "rgb(255,0,0)",
      marginLeft: 10,
      display: "inline-block",
    },
    eyButton: {
      textTransform: "none",
      borderRadius: !rounded && 0,
      "&:disabled": {
        backgroundColor: "rgba(0, 0, 0, 0.12)",
      },
    },
    loadingWrapper: {
      display: "inline-block",
    },
    staticButton: {
      cursor: "default",
    },
  }))
  const classes = useStyles(rounded)

  const emptyFunction = () => {}
  return (
    <span
      className={clsx({
        [classes.wrapper]: wrapped,
        [wrapperStyling]: wrapperStyling,
      })}
      id={id}
    >
      <div css={`
        display:inline-flex;
        flex-direction:column;
      `}>
      <div>
      <MaterialButton
        className={clsx({
          [classes.eyButton]: true,
          [className]: true,
          [classes.staticButton]: staticButton,
        })}
        disabled={disabled}
        onClick={staticButton ? emptyFunction : onClick}
        variant={variant || "contained"}
        color={color}
        component={component}
        startIcon={startIcon}
        endIcon={endIcon}
        ref={buttonRef}
        disableRipple={staticButton}
        disableFocusRipple={staticButton}
        disableElevation={staticButton}
        size={size}
      >        
        {children}
      </MaterialButton>
      {errorMessage && (
        <div className={classes.errorMessage}>{errorMessage}</div>
      )}
      </div>
      <div css={`width:100%;`}>
      {(loading) && (
        <Progress size={size === "small" ? 12 : 24} time={time} />
        )}
        </div>
      </div>

      
    </span>
  )
}

const Button=React.memo(_Button)
export default Button
